import React, { ReactNode } from 'react';
import { Menu, MenuProps } from '@chakra-ui/react';

interface Props extends MenuProps {
  children: ReactNode;
}

export const Dropdown = ({ children, ...props }: Props): JSX.Element => {
  return <Menu {...props}>{children}</Menu>;
};
export type { Props as DropdownProps };
